<template>
  <div class="grid grid-cols-12 items-center overflow-auto px-5 py-3 gap-5">
    <label class="col-span-12 md:col-span-2 text-xl font-bold">
      {{ $t("labels.generic", { pt: "Lista de objetos", en: "Objects List" }) }}
    </label>
    <div class="col-span-6 md:col-span-5">
      <span class="p-input-icon-right w-full">
        <i class="pi pi-search text-h-primary-500 cursor-pointer" @click="onSearch()" />
        <InputText
          v-model="searchWord"
          :placeholder="$t('labels.generic', { pt: 'Pesquisar', en: 'Search' })"
          class="w-full"
          @keyup.enter="onSearch()"
        />
      </span>
    </div>

    <div class="col-span-6 md:col-span-3">
      <Dropdown
        v-model="selected"
        :options="filters"
        optionLabel="name"
        class="w-full"
        @change="onSelect()"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { MaterialLearningGroupType } from "@/models/material.model";
import { defineComponent } from "@vue/runtime-core";

export default defineComponent({
  name: "listHeader",
  emits: ["onSelect", "onSearch"],
  data() {
    return {
      filters: [
        {
          name: this.$t("labels.generic", { pt: "Todos", en: "All" }),
          query: "",
          active: 0,
        },
        {
          name: this.$t("objects.type.motivation"),
          query: MaterialLearningGroupType.MOTIVATION,
          active: 1,
        },
        {
          name: this.$t("objects.type.intro"),
          query: MaterialLearningGroupType.INTRODUCTION,
          active: 2,
        },
        {
          name: this.$t("objects.type.dev"),
          query: MaterialLearningGroupType.DEVELOPMENT,
          active: 3,
        },
        {
          name: this.$t("objects.type.closure"),
          query: MaterialLearningGroupType.CLOSURE,
          active: 4,
        },
      ],
      selected: {
        name: this.$t("labels.generic", { pt: "Todos", en: "All" }),
        query: "",
        active: 0,
      } as any,
      searchWord: "" as string,
    };
  },
  mounted() {
    this.selected.active = 0;
  },
  methods: {
    onSelect(): void {
      this.$emit("onSelect", this.selected?.query);
    },
    onSearch(): void {
      this.$emit("onSearch", this.searchWord);
    },
  },
});
</script>
